(function () {
  // "Читати більше": hide the toggle when the text is short enough anyway.
  function markShortReadMore(root) {
    root.querySelectorAll('.blush-read-more').forEach(function (el) {
      if (el.classList.contains('is-expanded')) return;
      if (el.scrollHeight <= el.clientHeight + 8) el.classList.add('is-short');
    });
  }

  // "Вам також може сподобатись" repeated products from "Завершіть ритуал".
  function dedupeRecommendations(recommendations) {
    var series = document.querySelector('.rituals-series-products');
    if (!series) return;

    var seriesPaths = new Set();
    series.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      seriesPaths.add(new URL(link.href, location.origin).pathname);
    });
    if (!seriesPaths.size) return;

    var items = Array.prototype.slice.call(recommendations.querySelectorAll('.grid__item'));
    var visible = items.filter(function (item) {
      var link = item.querySelector('a[href*="/products/"]');
      var isDuplicate = link && seriesPaths.has(new URL(link.href, location.origin).pathname);
      if (isDuplicate) item.hidden = true;
      return !isDuplicate;
    });

    // Keep full rows in the two-column mobile grid.
    if (visible.length > 1 && visible.length % 2 === 1) visible[visible.length - 1].hidden = true;
  }

  function watchRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (element) {
      if (element.querySelector('.grid__item')) dedupeRecommendations(element);
      new MutationObserver(function () {
        if (element.querySelector('.grid__item')) dedupeRecommendations(element);
      }).observe(element, { childList: true });
    });
  }

  var phone = window.matchMedia('(max-width: 749px)');

  // Show a fixed bar while `target` is out of view (phones only).
  // With `onlyAfterPassed` the bar appears only once the target has scrolled above the viewport.
  function toggleWhileHidden(target, onChange, onlyAfterPassed) {
    if (!target) return;
    var last = null;
    var queued = false;

    function check() {
      queued = false;
      if (!target.isConnected) return;
      var rect = target.getBoundingClientRect();
      var passed = rect.bottom < 0;
      var below = rect.top > window.innerHeight;
      var hidden = onlyAfterPassed ? passed : passed || below;
      var show = phone.matches && hidden;
      if (show !== last) {
        last = show;
        onChange(show);
      }
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  // ---------- Product page: sticky add-to-cart bar ----------
  function initStickyAtc() {
    var bar = document.querySelector('[data-blush-sticky-atc]');
    if (!bar || bar.closest('.quick-add-modal')) return;
    document.body.appendChild(bar); // escape transformed ancestors so position: fixed works

    var form = document.getElementById(bar.dataset.formId);
    var mainButton = form && form.querySelector('[name="add"]');
    if (!mainButton) return;

    var priceTarget = bar.querySelector('[data-blush-sticky-price]');
    var stickyButton = bar.querySelector('[data-blush-sticky-add]');

    function sync() {
      var price = document.querySelector('.product__price-mobile-main') ||
        document.querySelector('.product__info-container .price-item--last');
      if (price && price.textContent.trim()) priceTarget.textContent = price.textContent.trim();
      var soldOut = mainButton.disabled;
      stickyButton.disabled = soldOut;
      stickyButton.textContent = soldOut ? bar.dataset.soldOutLabel : bar.dataset.addLabel;
    }

    stickyButton.addEventListener('click', function () {
      mainButton.click();
    });

    var info = document.querySelector('.product__info-container');
    if (info) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(sync, 150);
      }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    sync();

    toggleWhileHidden(mainButton, function (show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyButton.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('blush-sticky-atc-visible', show);
    }, true);
  }

  // ---------- Product page: compact delivery estimate (Kyiv time) ----------
  function initDeliveryLine() {
    var box = document.querySelector('[data-blush-delivery]');
    if (!box) return;

    // Texts come from the locale files through data attributes (blush-delivery-line.liquid);
    // dates are formatted in the page language.
    var text = box.dataset;
    var onWeekday = (text.weekdays || '').split('|');
    if (!text.shipToday || !text.shipLater || !text.eta || onWeekday.length !== 7) return;
    var lang = document.documentElement.lang || 'uk';

    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Kyiv', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23',
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });

    var DAY = 86400000;
    var today = Date.UTC(+parts.year, +parts.month - 1, +parts.day);
    var weekday = function (t) { return new Date(t).getUTCDay(); };
    var fmt = function (t) {
      return new Intl.DateTimeFormat(lang, { timeZone: 'UTC', day: 'numeric', month: 'short' }).format(new Date(t)).replace('.', '');
    };

    var ship = today;
    var shipText;
    if (weekday(today) !== 0 && +parts.hour < 13) {
      shipText = text.shipToday;
    } else {
      ship = today + DAY;
      while (weekday(ship) === 0) ship += DAY;
      var when = ship - today === DAY ? text.tomorrow : onWeekday[weekday(ship)];
      shipText = text.shipLater.replace('{day}', when).replace('{date}', fmt(ship));
    }

    var from = ship + DAY;
    var to = ship + 3 * DAY;
    var fromText = fmt(from);
    var toText = fmt(to);
    var sameMonth = new Date(from).getUTCMonth() === new Date(to).getUTCMonth();
    var range = sameMonth ? fromText.split(' ')[0] + '–' + toText : fromText + ' – ' + toText;

    box.querySelector('[data-blush-delivery-ship]').innerHTML = shipText;
    box.querySelector('[data-blush-delivery-eta]').textContent = text.eta.replace('{dates}', range);

    // Show the estimate only while the selected variant can be bought:
    // a sold-out or unavailable variant disables the main add-to-cart button.
    var info = box.closest('.product__info-container') || document;
    function sync() {
      var addButton = info.querySelector('product-form [name="add"]');
      box.hidden = !addButton || addButton.disabled;
    }
    if (info !== document) {
      new MutationObserver(sync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    sync();
  }

  // ---------- Product page: gallery dots instead of "1/3" ----------
  function initGalleryDots() {
    document.querySelectorAll('media-gallery .product__media-list').forEach(function (list) {
      if (list.dataset.blushDots) return;
      var slides = Array.prototype.filter.call(list.children, function (li) {
        return li.offsetParent !== null || getComputedStyle(li).display !== 'none';
      });
      if (slides.length < 2) return;
      list.dataset.blushDots = '1';

      var dots = document.createElement('div');
      dots.className = 'blush-gallery-dots';
      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'blush-gallery-dots__dot';
        dot.setAttribute('aria-label', 'Фото ' + (index + 1));
        dot.addEventListener('click', function () {
          list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
      list.parentElement.appendChild(dots);

      function update() {
        var index = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
        Array.prototype.forEach.call(dots.children, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  // ---------- Cart page: sticky checkout bar ----------
  function initCartBar() {
    var checkout = document.getElementById('checkout');
    if (!checkout) return;
    toggleWhileHidden(checkout, function (show) {
      document.body.classList.toggle('blush-cart-bar-visible', show);
    });
  }

  // ---------- Collection: "Показати ще" instead of page numbers ----------
  function initLoadMore() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // Localized texts can be passed as data attributes on #ProductGridContainer
    // (data-load-more, data-load-more-loading, data-load-more-status with {shown} and {total});
    // without them the Ukrainian texts below are used.
    var labels = {
      more: container.dataset.loadMore || 'Показати ще',
      loading: container.dataset.loadMoreLoading || 'Завантажуємо…',
      status: container.dataset.loadMoreStatus || 'Показано {shown} з {total}',
    };

    function setup() {
      var grid = container.querySelector('#product-grid');
      var pagination = container.querySelector('.pagination-wrapper');
      var old = container.querySelector('.blush-load-more');
      if (old) old.remove();
      // Collection grids only: there #product-grid is the <ul> of cards. On search it is a <div> with separate
      // product and article/page lists, and each page mixes both, so search keeps the normal pagination.
      if (!grid || !pagination || grid.tagName !== 'UL') return;

      var next = pagination.querySelector('.pagination__item--prev'); // Dawn names the "next" arrow --prev
      if (!next || !next.href) return;

      // The number comes from data-product-count (the filtered count, updated by facets.js), not from the
      // localized text: "Продуктов: 240" on /ru does not start with a digit.
      var count = document.getElementById('ProductCount');
      var total = count ? parseInt(count.dataset.productCount, 10) : NaN;
      var wrap = document.createElement('div');
      wrap.className = 'blush-load-more';
      var status = document.createElement('p');
      status.className = 'blush-load-more__status';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary blush-load-more__button';
      button.textContent = labels.more;
      wrap.appendChild(status);
      wrap.appendChild(button);
      pagination.parentNode.insertBefore(wrap, pagination);

      function updateStatus() {
        var shown = grid.children.length;
        status.textContent = total ? labels.status.replace('{shown}', shown).replace('{total}', total) : '';
      }
      updateStatus();

      button.addEventListener('click', function () {
        var url = next.href;
        button.disabled = true;
        button.textContent = labels.loading;
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = doc.querySelectorAll('#product-grid > li');
            items.forEach(function (item) {
              item.classList.remove('scroll-trigger', 'animate--slide-in');
              grid.appendChild(document.importNode(item, true));
            });
            var newPagination = doc.querySelector('.pagination-wrapper');
            // Keep the page numbers in sync with what has been loaded.
            if (newPagination) {
              var imported = document.importNode(newPagination, true);
              pagination.replaceWith(imported);
              pagination = imported;
            }
            var newNext = newPagination && newPagination.querySelector('.pagination__item--prev');
            if (newNext && newNext.getAttribute('href')) {
              next = { href: new URL(newNext.getAttribute('href'), location.origin).href };
              button.disabled = false;
              button.textContent = labels.more;
            } else {
              button.remove();
            }
            if (window.blushSplitTitles) window.blushSplitTitles(grid);
            updateStatus();
          })
          .catch(function () {
            window.location.href = url;
          });
      });
    }

    setup();
    new MutationObserver(function (mutations) {
      var replaced = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')));
        });
      });
      if (replaced) setup();
    }).observe(container, { childList: true, subtree: true });
  }

  function init() {
    markShortReadMore(document);
    watchRecommendations();
    initStickyAtc();
    initDeliveryLine();
    initGalleryDots();
    initCartBar();
    initLoadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
